import React, { useContext, useEffect, useState, useRef } from "react";
import { API } from "aws-amplify";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, TextField, MenuItem, Typography } from "@material-ui/core";
import { useField } from "react-final-form";
import useForm from "../../../../utils/useForm";
import SetupContext, { validateSubscription } from "./context";

import { useNotify } from "react-admin";
import { logError } from "../../../../utils/appUtils";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
}));

export default function Subscription() {
  const classes = useStyles();
  const notify = useNotify();
  const isComponentMounted = useRef(true);
  const { state, dispatch } = useContext(SetupContext);
  const { subscription } = state;

  const [products, setProducts] = useState([]);
  const [prices, setPrices] = useState([]);
  const [priceList, setPriceList] = useState([]);

  const {
    input: { onChange },
  } = useField("setupData");

  useEffect(() => {
    if (isComponentMounted) getData();
    return () => (isComponentMounted.current = false);
  }, []);

  useEffect(() => {
    if (prices && subscription) {
      const newPices = prices.filter(
        (price) => price.product === subscription.productId
      );
      setPriceList(newPices);
    }
  }, [prices, subscription]);

  const getData = async () => {
    try {
      const response = await API.post(
        "transREST",
        "/stripe-list-products-prices",
        {
          body: {
            active: true,
          },
        }
      );
      debugger;

      if (response.err)
        logError(
          "newYardData:Subscription:getData:response",
          response.err,
          notify
        );
      else {
        setProducts(response.productList.products.data);
        setPrices(response.productList.prices.data);

        const productPrices = response.productList.prices.data.filter(
          (price) => price.product === state.subscription?.productId
        );
        setPriceList(productPrices);
      }
    } catch (err) {
      logError("newYardData:Subscription:getData", err, notify);
    }
  };

  const { handleChange } = useForm(
    state,
    dispatch,
    "subscription",
    "SET_SUBSCRIPTION"
  );

  const handleRecordChange = (evt) => {
    //Set subscription.productId
    debugger;
    handleChange(evt);
    onChange();
  };

  const handleProduct = (evt) => {
    debugger;
    const productPrices = prices.filter(
      (price) => price.product === evt.target.value
    );
    setPriceList(productPrices);
    handleRecordChange(evt);
    dispatch({ type: "SET_PRODUCT_PRICES", payload: productPrices });
  };

  const handleBlur = (evt) => {
    const errors = validateSubscription(state.subscription);
    dispatch({ type: "ERROR", payload: errors });
  };

  let { errors } = state;

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="subtitle1">Set Up Subscription</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            name="productId"
            label="Product"
            id="productId"
            select
            margin="dense"
            variant="outlined"
            fullWidth
            required
            helperText={errors["productId"] ? errors["productId"] : ""}
            error={errors["productId"] ? true : false}
            value={subscription?.productId ? subscription.productId : ""}
            onChange={handleProduct}
            onBlur={handleBlur}
          >
            <MenuItem key="product.id" value="product.id"></MenuItem>
            {products.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          Prices:
          <ul id="priceId" margin="dense" variant="outlined" fullWidth>
            {priceList.map((option) => (
              <li key={option.id} id={option.id}>
                {option.nickname
                  ? option.nickname
                  : `<< ${option.unit_amount / 100} ${option.currency} : ${
                      option.type === "one_time"
                        ? option.type
                        : option.recurring.interval
                    } >>`}
              </li>
            ))}
          </ul>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            name="trialPeriod"
            label="Trial Period (Days)"
            id="trialPeriod"
            type="number"
            margin="dense"
            variant="outlined"
            fullWidth
            required
            helperText={errors["trialPeriod"] ? errors["trialPeriod"] : ""}
            error={errors["trialPeriod"] ? true : false}
            value={subscription?.trialPeriod}
            onChange={handleRecordChange}
            onBlur={handleBlur}
          />
        </Grid>
      </Grid>
    </div>
  );
}
